const LOG_LEVEL = import.meta.env.VITE_LOG_LEVEL

// TODO: Maybe replace with sessionStorage?
window.Sanitas = window.Sanitas || {}
window.Sanitas.DVP = window.Sanitas.DVP || {}
window.Sanitas.DVP.log_level = LOG_LEVEL

function getLogLevel() {
  return window.Sanitas.DVP.log_level
}

export default function useLogger() {
  const SEVERITY = {
    ERROR: 'error',
    WARNING: 'warn',
    INFO: 'info',
  }

  function log(severity, params) {
    const level = getLogLevel()
    if (!level || level === '') return
    if (!level.includes(severity.toUpperCase())) return

    if (Array.isArray(params)) {
      console[severity](...params)
    } else {
      console[severity](params)
    }
  }

  function logError(params) {
    log(SEVERITY.ERROR, params)
  }

  function logInfo(params) {
    log(SEVERITY.INFO, params)
  }

  function logWarning(params) {
    log(SEVERITY.WARNING, params)
  }

  return {
    logError,
    logInfo,
    logWarning
  }
}
